import { render } from "./AdminLiaWizard.vue?vue&type=template&id=6298f0c2&scoped=true"
import script from "./AdminLiaWizard.vue?vue&type=script&lang=js"
export * from "./AdminLiaWizard.vue?vue&type=script&lang=js"

import "./AdminLiaWizard.vue?vue&type=style&index=0&id=6298f0c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6298f0c2"]])

export default __exports__